"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTransitTimeClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const errors_1 = require("@deliverr/errors");
const commons_logs_1 = require("@deliverr/commons-logs");
const commons_objects_1 = require("@deliverr/commons-objects");
const client_auth_1 = require("@deliverr/client-auth");
class AbstractTransitTimeClient extends base_client_1.ApiClient {
    constructor(config) {
        const clientConfig = Object.assign({}, config);
        if (!clientConfig.baseURL) {
            commons_logs_1.log.warn("TRANSIT_TIME_SERVICE_URL environment variable is required or the baseURL must be provided in the config");
        }
        if (clientConfig.authEngine === commons_objects_1.AuthEngine.BASIC) {
            commons_logs_1.log.warn("Basic Auth will be deprecated for Transit Time");
            if (!clientConfig.basicAuthUser || !clientConfig.basicAuthPassword) {
                commons_logs_1.log.warn("AuthEngine set to BASIC and TRANSIT_TIME auth not set");
            }
            else {
                clientConfig.auth = {
                    username: clientConfig.basicAuthUser,
                    password: clientConfig.basicAuthPassword,
                };
            }
        }
        else if (config.authEngine === commons_objects_1.AuthEngine.COGNITO_INTERNAL) {
            if (!config.tokenRefreshFn) {
                const clientTokenBuilder = new client_auth_1.OAuthClientTokenBuilder(clientConfig);
                const tokenRefreshFn = clientTokenBuilder.getTokenFn();
                clientConfig.tokenRefreshFn = tokenRefreshFn;
            }
        }
        else {
            throw new errors_1.DeliverrError(`Unsupported Auth Engine ${clientConfig.authEngine}`);
        }
        super(clientConfig);
        this.prefix = clientConfig.prefix;
    }
}
exports.AbstractTransitTimeClient = AbstractTransitTimeClient;
//# sourceMappingURL=AbstractTransitTimeClient.js.map